import 'react-app-polyfill/stable';
import 'classlist-polyfill';
import 'console-polyfill';
import 'document.contains/auto';
import 'element-closest';
import 'intersection-observer';
import 'ric-shim';
import 'shim-keyboard-event-key';
import 'resize-observer-polyfill';

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
